import {
    makeStyles
} from '@material-ui/core';
import React, {useEffect, useRef, useState} from 'react';
import { useHistory } from 'react-router-dom';
import ErrorCardController from "../../UiComponents/ErrorCardController";
import {TrafficShapingService} from "../../../Domain/Services/TrafficShapingService";
import {TrafficShapingStatus} from "../../../Domain/Models/TrafficShapingStatus";
import TrafficShapingStatusContent from "./TrafficShapingStatusContent";
import QueueList from "./QueueList";
import KickedGroupList from "./KickedGroupList";
import Loading from "../../UiComponents/Loading";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    title: {
        flexGrow: 1
    },
    clickableCell: {
        cursor: 'pointer',
    },
}));

let requestInProgressRef = false;
export default function TrafficShapingContent()
{
    const classes = useStyles();
    const history = useHistory();

    const errorCardControllerRef = useRef<ErrorCardController>(null);

    const [trafficShapingStatus, setTrafficShapingStatus] = useState<TrafficShapingStatus>();
    const [loading, setLoading] = useState(true);
    const [requestInProgress, setRequestInProgress] = useState(false);

    requestInProgressRef = requestInProgress;
    const updateStatus = () =>
    {
        if (requestInProgressRef)
        {
            return;
        }
        
        setRequestInProgress(true);
        TrafficShapingService.getStatus()
            .then((result) =>
            {
                setTrafficShapingStatus(result);
                setLoading(false);
                setRequestInProgress(false);
            })
            .catch((e: Error) =>
            {
                errorCardControllerRef.current?.addErrorMessage(e.message);
                setLoading(false);
                setRequestInProgress(false);
            })
    }
    
    const forceUpdate = () =>
    {
        setLoading(true);
        updateStatus();
    }

    useEffect(() =>
    {
        updateStatus();
        
        const repeating = setInterval(updateStatus, 10000);
        return () => clearTimeout(repeating);
    }, [])

    return (
        <>
            <Loading isLoading={loading}>
                <ErrorCardController ref={errorCardControllerRef}/>
    
                <TrafficShapingStatusContent
                    errorCardControllerRef={errorCardControllerRef}
                    updateStatus={updateStatus}
                    trafficShapingStatus={trafficShapingStatus}
                    requestInProgress={requestInProgress}
                />
                <QueueList
                  trafficShapingStatus={trafficShapingStatus}
                  errorCardController={errorCardControllerRef}
                  forceUpdate={forceUpdate}
                />
                <KickedGroupList
                  trafficShapingStatus={trafficShapingStatus}
                  errorCardController={errorCardControllerRef}
                  forceUpdate={forceUpdate}
                />
            </Loading>
        </>
    );
}